export function issuerInstitutions() {
    return [
        { name: 'ABC Issuer Corp.', value: 'abcissuercorp' },
        { name: 'Bank B Corp.', value: 'bankbcorp' },
        { name: 'Bank C Corp.', value: 'bankccorp' },
        { name: 'Petron Corporation', value: 'petroncorporation' },
        { name: 'Amalgamated Investment Bank Corporation', value: 'amalgamatedinvestmentbankcorporation' },
        { name: 'Asia United Bank Corporation', value: 'asiaunitedbankcorporation' },
        { name: 'Bank of Commerce', value: 'bankofcommerce' },
        { name: 'Bank of Makati A Savings Bank Inc.', value: 'bankofmakatiasavingsbankinc' },
        { name: 'Bank of the Philippine Islands', value: 'bankofthephilippineislands' },
        { name: 'DL Industries Inc.', value: 'dlindustriesinc' },
        { name: 'BDO Capital & Investment Corporation', value: 'bdocapitalinvestmentcorporation' },
        { name: 'BDO Private Bank, Inc.', value: 'bdoprivatebankinc' },
        { name: 'BDO Securities Corporation', value: 'bdosecuritiescorporation' },
        { name: 'BDO Unibank, Inc.', value: 'bdounibankinc' },
        { name: 'BPI Capital Corporation', value: 'bpicapitalcorporation' },
        { name: 'China Banking Corporation', value: 'chinabankingcorporation' },
        { name: 'China Bank Capital Corporation', value: 'chinabankcapitalcorporation' },
        { name: 'CTBC Bank (Philippines) Corp.', value: 'ctbcbankphilippinescorp' },
        { name: 'Citicorp Financial Services and Insurance Brokerage (Phils.), Inc.', value: 'citicorpfinancialservicesandinsurancebrokeragephilsinc' },
        { name: 'Development Bank of the Philippines', value: 'developmentbankofthephilippines' },
        { name: 'EastWest Banking Corporation', value: 'eastwestbankingcorporation' },
        { name: 'First Metro Investment Corporation', value: 'firstmetroinvestmentcorporation' },
        { name: 'First Metro Securities Brokerage Corporation', value: 'firstmetrosecuritiesbrokeragecorporation' },
        { name: 'Land Bank of the Philippines', value: 'landbankofthephilippines' },
        { name: 'Maybank Philippines, Inc.', value: 'maybankphilippinesinc' },
        { name: 'Metropolitan Bank & Trust Company', value: 'metropolitanbanktrustcompany' },
        { name: 'Multinational Investment Bancorporation', value: 'multinationalinvestmentbancorporation' },
        { name: 'Philippine Business Bank', value: 'philippinebusinessbank' },
        { name: 'Philippine Bank of Communications', value: 'philippinebankofcommunications' },
        { name: 'Philippine Commercial Capital, Inc.', value: 'philippinecommercialcapitalinc' },
        { name: 'Philippine National Bank', value: 'philippinenationalbank' },
        { name: 'PNB Capital and Investment Corporation', value: 'pnbcapitalandinvestmentcorporation' },
        { name: 'Philippine Veterans Bank', value: 'philippineveteransbank' },
        { name: 'Rizal Commercial Banking Corporation', value: 'rizalcommercialbankingcorporation' },
        { name: 'RCBC Capital Corporation', value: 'rcbccapitalcorporation' },
        { name: 'PDEX', value: 'pdex' },
        { name: 'Robinsons Bank Corporation', value: 'robinsonsbankcorporation' },
        { name: 'SB Capital Investment Corporation', value: 'sbcapitalinvestmentcorporation' },
        { name: 'Standard Chartered Bank', value: 'standardcharteredbank' },
        { name: 'Sterling Bank of Asia, Inc. (A Savings Bank)', value: 'sterlingbankofasiaincasavingsbank' },
        { name: 'The Hongkong and Shanghai Banking Corporation Limited', value: 'thehongkongandshanghaibankingcorporationlimited' },
        { name: 'Filinvest Land, Inc.', value: 'filinvestlandinc' },
        { name: 'UniCapital, Inc.', value: 'unicapitalinc' },
        { name: 'Union Bank of the Philippines', value: 'unionbankofthephilippines' },
        { name: 'United Coconut Planters Bank', value: 'unitedcoconutplantersbank' },
        { name: 'Ayala Land, Inc.', value: 'ayalalandinc' },
        { name: 'SL Agritech Corporation', value: 'slagritechcorporation' },
        { name: 'Ayala Corporation', value: 'ayalacorporation' },
        { name: 'Philippine Dealing & Exchange Corp.', value: 'philippinedealingexchangecorp' },
        { name: 'Aboitiz Equity Ventures', value: 'aboitizequityventures' },
        { name: 'Phinma Corporation', value: 'phinmacorporation' },
        { name: 'Aboitiz Power Corporation', value: 'aboitizpowercorporation' },
        { name: 'SMC Global Power Holdings Corp.', value: 'smcglobalpowerholdingscorp' },
        { name: 'ING Bank N.V. Manila Branch', value: 'ingbanknvmanilabranch' },
        { name: 'Megawide Construction Corporation', value: 'megawideconstructioncorporation' },
        { name: 'Robinsons Land Corporation', value: 'robinsonslandcorporation' },
        { name: 'ACEN Corporation', value: 'acencorporation' },
        { name: 'Cebu Landmasters, Inc.', value: 'cebulandmastersinc' },
        { name: 'CITICORE Energy REIT Corp.', value: 'citicoreenergyreitcorp' }
    ];
}
